//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  computed: {
    isCollapse () {
      return this.blok.style === 'collapse'
    },
    sectionClass () {
      if (this.blok.bg === 'white') {
        return 'tw-bg-white'
      }
      return 'tw-bg-cream-50'
    }
  }
}
